<template>
    <div>
        <slot v-if="ssr" name="body" />
        <template v-else>
            <div class="container">
                <div class="breadcrumb-container">
                    <nav aria-label="breadcrumb">
                        <ul class="breadcrumb pl-0">
                            <li 
                                v-for="(breadcrumb_item, index) in breadcrumb"
                                :key="index"
                                class="breadcrumb-item"
                                :class="{'active': breadcrumb_item['title'] == breadcrumb[breadcrumb.length - 1]['title']}"
                            >
                                <a v-if="breadcrumb_item['url'] != undefined" :href="breadcrumb_item['url']" v-html="breadcrumb_item['title']"></a>
                                <span v-else v-html="breadcrumb_item['title']"></span>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    data() {
        return {
            ssr: true,
            breadcrumb: null
        }
    },

    mounted() {
        window.events.$on('list.breadcrumb', event => {
            this.breadcrumb = event
            this.ssr = false
        })
    }
}
</script>